import clsx from "classnames";
import classes from "./styles.module.scss";
import HeaderTitle from "@/components/HeaderTitle";
import Link from 'next/link';
import Title from '@/ui/Title';
import Image from "@/ui/Image";
export default function ContactHero({ image, highlightTitle, title, subtitle, description, button="t1", buttonLabel, buttonLink="", dark, className }) {

  return (
    <div className={clsx(className, classes.hero )}>
      <div className={dark && classes.dark_bg}></div>
      <div className={classes.left_section}>
        {image ? <Image className={classes.image} img={image} alt={""} size="1000x563" /> : <></>}
      </div>
      <div className={classes.right_section}>
        <div className={classes.content}>
          {/* { highlightTitle &&
            <div className={classes.highlight_title}>
              <HeaderTitle title={highlightTitle} tag="h3" fontSize="40px" lineHeight="40px"/>
            </div>
          } */}
          <Title tag="h3" containerClass={"contact-highlight-title"} title={title} className={`h2`} variant="primary" highlight={true} />

          {/* <span className={classes.title}>{title}</span> */}
          <span className={classes.subtitle}>{subtitle}</span>
          <span className={classes.description}>{description}</span>
        </div>
        <Link href={buttonLink} passHref>
          <button className={clsx(classes.contact_btn, button === "t1" && classes.t1, button === "t4" && classes.t4)}>{buttonLabel}</button>
        </Link>
      </div>
    </div>
  );
}

ContactHero.defaultProps = {
  className: "",
};
